import { UseMutationOptions } from '@tanstack/react-query';
import useAppMutation from 'hooks/useAppMutation';
import { BaseErrorResponse } from 'models/_base';
import API from 'services/API';

type UsePreAuthorizationReleaseMutationArgs = {
  preAuthorizationUid: string;
};

type ReactQueryMutationOptions = Omit<
  UseMutationOptions<
    unknown,
    BaseErrorResponse,
    UsePreAuthorizationReleaseMutationArgs
  >,
  'mutationFn' | 'mutationKey'
>;

const releasePreAuthorization = async ({
  preAuthorizationUid,
}: UsePreAuthorizationReleaseMutationArgs) => {
  const response = await API.post(
    `/api/internal/security-deposit/pre-authorizations/${preAuthorizationUid}/release`,
  );
  return response.data;
};

const usePreAuthorizationReleaseMutation = ({
  ...options
}: ReactQueryMutationOptions = {}) => {
  return useAppMutation({
    mutationFn: releasePreAuthorization,
    ...options,
  });
};

export default usePreAuthorizationReleaseMutation;
